var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHe1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "he1",
    transform: "translate(-1573 276)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_825",
    "data-name": "Rectangle 825",
    width: 50,
    height: 50,
    transform: "translate(1573 -276)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Component_15_7",
    "data-name": "Component 15 \\u2013 7",
    transform: "translate(1579 -268)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    "data-name": "Path 121",
    d: "M150.58,305.166a15.057,15.057,0,0,1-23.155,0,3.308,3.308,0,1,0-5.086,4.231,21.7,21.7,0,0,0,33.327,0,3.308,3.308,0,1,0-5.086-4.231Z",
    transform: "translate(-120.254 -283.031)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    "data-name": "Path 122",
    d: "M115.355,160.132a4.654,4.654,0,0,1,8.683,0l1.309,2.343a1.091,1.091,0,0,0,1.282.51,1.1,1.1,0,0,0,.786-1.144c-.455-5.8-4.438-9.841-7.718-9.841s-7.264,4.038-7.718,9.841a1.115,1.115,0,0,0,.786,1.144,1.129,1.129,0,0,0,1.282-.51Z",
    transform: "translate(-111.975 -152)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123",
    "data-name": "Path 123",
    d: "M279.7,152c-3.28,0-7.264,4.038-7.718,9.841a1.109,1.109,0,0,0,2.067.634l1.309-2.343a4.654,4.654,0,0,1,8.683,0l1.309,2.343a1.091,1.091,0,0,0,1.282.51,1.1,1.1,0,0,0,.786-1.144C286.96,156.038,282.977,152,279.7,152Z",
    transform: "translate(-249.922 -152)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHe1);
export default __webpack_public_path__ + "static/media/he1.412196fd5c368c92b7fa33a99058d04c.svg";
export { ForwardRef as ReactComponent };